import PrintIcon from "@mui/icons-material/Print";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, {useRef} from "react";
import {useTranslation} from "react-i18next";

import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useReactToPrint} from "react-to-print";

import {getServiceReceiptById} from "../../services/requests/ApiRequests";

export default function ServiceReceipt() {
	let params = useParams();
	const {t} = useTranslation();

	let navigate = useNavigate();
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	const [number, setNumber] = React.useState("000000");
	// const [id, setId] = React.useState({id: params.receiptId});

	const [receipt, setReceipt] = React.useState({});
	const [loading, setLoading] = React.useState(true);

	const [searchParams] = useSearchParams();
	const searchParamsObj = Object.fromEntries(searchParams);
	const ridFromQuery = searchParams.get("rid");

	React.useEffect(() => {
		getServiceReceiptById(params.receiptId, searchParamsObj).then(
			(data) => {
				setReceipt(data.data);
				setLoading(false);
				var str = data.data.soap_data.id.toString();
				let pad = "000000";
				let new_number =
					pad.substring(0, pad.length - str.length) + str;
				setNumber(new_number);
			}
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (loading) {
		return (
			<div align="center">
				<CircularProgress/>
			</div>
		);
	}
	return (
		<Box sx={{flexGrow: 1, marginTop: 5, marginLeft: 10}}>
			<Grid container spacing={2} align="left">
				<Grid item xs={5}>
					<Typography
						sx={{fontSize: 28}}
						color="pimary"
						gutterBottom
					>
						{t("viewing_service_receipt")}
					</Typography>
					<Button
						variant="text"
						color="secondary"
						onClick={() => {
							if (ridFromQuery) {
								navigate(
									`/acps/service-receipts?rid=${ridFromQuery}`
								);
							} else {
								navigate("/acps/service-receipts");
							}
						}}
					>
						&#60; {t("back_to_service_receipt_journal_btn")}
					</Button>
					<Divider/>
					<Grid container spacing={2} align="left">
						<Grid item xs={8}>
							<Typography
								sx={{fontSize: 20}}
								color="pimary"
								gutterBottom
							></Typography>
						</Grid>
						<Grid item xs={4}>
							<Typography
								sx={{fontSize: 20}}
								color="pimary"
								gutterBottom
							>
								{receipt.status}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("service_receipt_number")}:
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{number}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("formed_date")}:
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{receipt.soap_data.datetime.split("T")[0]}{" "}
								{receipt.soap_data.datetime.split("T")[1]}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("serial_number_kkm")}:
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{receipt.soap_data.card.number}
							</Typography>
						</Grid>

						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								gutterBottom
							>
								{t("address")}:
							</Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography
								sx={{fontSize: 14}}
								color="pimary"
								gutterBottom
							>
								{receipt.soap_data.card.address}
							</Typography>
						</Grid>

						<Grid item xs={12} align="center">
							<Button
								variant="outlined"
								sx={{width: "75%"}}
								startIcon={<PrintIcon/>}
								onClick={handlePrint}
							>
								{t("print_receipt")}
							</Button>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={6}>
					<Card sx={{width: 375}} id="receipt" ref={componentRef}>
						<CardContent>
							<Typography
								variant="h5"
								component="h5"
								color="text.secondary"
								align="center"
							>
								{receipt.soap_data.card.name}
							</Typography>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								COD FISCAL: {receipt.soap_data.card.idnx}
							</Typography>
							<Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								{receipt.soap_data.card.address}
							</Typography>
							{receipt?.activity_type ? <Typography
								sx={{fontSize: 14}}
								color="text.secondary"
								align="center"
								gutterBottom
							>
								{t(`activity_${receipt?.activity_type || ''}`)}
							</Typography> : null}

							<Divider/>
							<Grid container spacing={2} align="left">
								<Grid item xs={7}>
									<Typography
										sx={{fontSize: 14, fontWeight: 600}}
										color="text.secondary"
										gutterBottom
									>
										{receipt.soap_data.data.type === 1 && (
											<>Încasare numerar</>
										)}
										{receipt.soap_data.data.type === 2 && (
											<>Extragere numerar</>
										)}
									</Typography>
								</Grid>
								<Grid item xs={5} align="right">
									<Typography
										sx={{
											fontSize: 14,
											fontWeight: 600,
											wordBreak: "break-all",
											textAlign: "right",
										}}
										color="text.secondary"
										gutterBottom
									>
										{receipt.soap_data.data.total}
									</Typography>
								</Grid>
							</Grid>

							<Divider/>
							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										NUMARUL DE IDENTIFICARE
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										{receipt?.soap_data?.id}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										Casier:
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										{receipt?.user?.login || '-'}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										BON DE SERVICIU
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										{receipt?.soap_data?.receipt}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										DATA:{" "}
										{
											receipt.soap_data.datetime.split(
												"T"
											)[0]
										}
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										ORA:{" "}
										{
											receipt.soap_data.datetime.split(
												"T"
											)[1]
										}
									</Typography>
								</Grid>
							</Grid>

							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										DATA MEV:{" "}
										{
											receipt?.soap_response?.datetime?.split(
												"T"
											)[0]
										}
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										ORA MEV:{" "}
										{
											receipt?.soap_response?.datetime?.split(
												"T"
											)[1]
										}
									</Typography>
								</Grid>
							</Grid>

							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										MEV ID:
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										{receipt.soap_response?.id ||
											receipt.soap_data?.id ||
											"N/A"}
									</Typography>
								</Grid>
							</Grid>
							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										NUMARUL DE INREGISTRARE:
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										{receipt.soap_data.card.number}
									</Typography>
								</Grid>
							</Grid>

							<Grid container spacing={2} align="left">
								<Grid item xs={8}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										SN:
									</Typography>
								</Grid>
								<Grid item xs={4} align="right">
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										{receipt.soap_data.card.factory}
									</Typography>
								</Grid>
							</Grid>

							<Divider/>

							<Grid container spacing={2} align="center">
								<Grid item xs={12}>
									<Typography
										sx={{fontSize: 14}}
										color="text.secondary"
										gutterBottom
									>
										*** BON DE SERVICIU ***
									</Typography>
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</Box>
	);
}
